var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconoAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.a{stroke:#3B5158;stroke-linecap:round;stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.175 2)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M22,12A10,10,0,1,1,12,2,10,10,0,0,1,22,12Z",
    transform: "translate(-2 -2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12,8v8",
    transform: "translate(-2 -2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8,12h8",
    transform: "translate(-2 -2)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 24,
    height: 24,
    transform: "translate(0.002)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoAdd);
export default __webpack_public_path__ + "static/media/iconoAdd.30313188ec3cf0600a495374faacf523.svg";
export { ForwardRef as ReactComponent };